<template src='./form-import.html'></template>

<script>
import { EventBus } from '@/router/bus'

export default {
  props: ['formName', 'jsonScheme', 'canEdit'],
  data () {
    return {
      importJsonFile: undefined,
      jsonDialog: false,
      jsonFormScheme: null
    }
  },
  watch: {
    jsonScheme (newValue) {
      this.jsonFormScheme = newValue
    },
    importJsonFile (newValue) {
      if (newValue) {
        var reader = new FileReader()
        reader.readAsText(newValue)
        reader.onload = () => {
          this.jsonFormScheme = reader.result
        }
      } else {
        this.jsonFormScheme = this.jsonScheme
      }
    }
  },
  methods: {
    openJsonDialog () {
      this.jsonDialog = true
    },
    importJson () {
      EventBus.$emit('saveJsonValues', this.jsonFormScheme)
      this.closeJsonDialog()
    },
    closeJsonDialog () {
      this.importJsonFile = undefined
      this.jsonDialog = false
    }
  }
}
</script>
